module.exports = __webpack_public_path__ + "img/Luonan_Chen.4a202c82.png";